import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AppShortcutIcon(props: IconProps) {
    return <Icon {...props} iconKey={"app_shortcut"}/>
}
